import { Module } from 'vuex';
import { RootState } from '../types';
import { TransportsState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: TransportsState = {
    transports: null,
    transportProtocols: [],
    protocolParameters: [],
    transportsMultichannel: [],
};


export const transports: Module<TransportsState,RootState> = {
    state,
    getters,
    actions,
    mutations
};